import { html, nothing, render } from "lit-html";
import connect from "@escapio/shared/data-store/connect";
import {
	STATE_WITHOUT_DATES,
	store,
} from "@escapio/portal/components/hotel/DataStore";
import { translate } from "@escapio/shared/l10n/translate";
import "../PriceFilterInfoWithoutDates";
import "./FilterCheckbox";
import "./TravelDataToggle";
import "./BoardFilter";
import "@escapio/portal/components/travel-data/CalendarView";
import "@escapio/portal/components/travel-data/GuestSelectorView";
import "@escapio/portal/components/travel-data/CalendarInput";
import "@escapio/portal/components/travel-data/GuestSelectorInput";
import { classMap } from "lit-html/directives/class-map.js";
import {
	travelData,
	updateDates,
	onChangeDates,
	updateRooms,
} from "@escapio/portal/state/travelData";
import { data } from "@escapio/shared/state/payload";

customElements.define(
	"esc-profile-price-header",
	class extends connect(HTMLElement, store) {
		connectedCallback() {
			super.connectedCallback();
			onChangeDates(() => {
				const toggle = this.querySelector(
					"esc-toggle.price-comparer__filters-toggle",
				);
				if (toggle) {
					setTimeout(toggle.updateHeight.bind(toggle));
				}
			});
		}

		update({ status, hasActiveEscapioRates }) {
			if (hasActiveEscapioRates) {
				render(nothing, this, { host: this });
				return;
			}

			const template = html`<header class="price-comparer__header">
					<h2 class="price-comparer__header__title">
						${
							data?.hotel?.exclusive
								? translate("hotel_heading_our_recommendation")
								: translate("hotel_heading_price_comparer")
						}
					</h2>

					<esc-hotel-travel-data-toggle
						class="clickable"
						toggable-selector=".travel-data-editor"
						.toggableContainer=${this}
						@open=${this.onOpenTravelData}
					>
						<i class="fa fa-calendar toggle__icon"></i>
						<esc-calendar-view class="travel-data-toggle__calendar">
						</esc-calendar-view>
						<i class="fa fa-users toggle__icon"></i>
						<esc-guest-selector-view class="travel-data-toggle__guests">
						</esc-guest-selector-view>
						<i class="fa fa-angle-down toggle__arrow"></i>
					</esc-hotel-travel-data-toggle>

					<div class="cancelation-filter-info-container">
						<esc-toggle
							class="price-comparer__filters-toggle clickable"
							toggable-selector=".price-comparer__filters"
							.toggableContainer=${this}
							@open=${this.onOpenFilters}
							><i class="fa fa-sliders toggle__icon"></i
							><span>${translate("hotel_price_comparer_filter")}</span
							><i class="fa fa-angle-down toggle__arrow"></i
						></esc-toggle>
					</div>
				</header>

				<div class="price-comparer__filters">
					<div
						class="price-comparer__filters__container ${classMap({
							"price-filter__container--info-shown":
								status === STATE_WITHOUT_DATES,
						})}"
					>
						${
							status === STATE_WITHOUT_DATES
								? html`<esc-price-filter-info-without-dates
										event-category="Hotel"
									></esc-price-filter-info-without-dates>`
								: html`<esc-profile-filter-checkbox
											label=${translate(
												"hotel_price_comparer_filter_cancelation",
											)}
											name="cancelation"
											event-label="Kostenlose Stornierung"
										></esc-profile-filter-checkbox>
										<esc-profile-board-filter></esc-profile-board-filter>`
						}
					</div>
				</div>

				<div class="travel-data-editor">
					<div class="travel-data-editor__container">
						<div class="travel-data-editor__title">
							${translate("hotel_page_change_travel_data")}
						</div>
						<esc-calendar-input
							.arrival=${travelData.arrival}
							.departure=${travelData.departure}
							@confirm=${this.confirmDates}
						></esc-calendar-input>
						<esc-guest-selector-input
							.rooms=${travelData.rooms}
							@confirm=${this.confirmRooms}
						></esc-guest-selector-input>
					</div>
				</div> `;
			render(template, this, { host: this });
		}

		onOpenFilters() {
			this.querySelector("esc-hotel-travel-data-toggle")?.close();
		}

		onOpenTravelData() {
			this.querySelector(".price-comparer__filters-toggle")?.close();
		}

		confirmDates({ detail }) {
			updateDates(detail.arrival, detail.departure);
		}

		confirmRooms({ detail }) {
			updateRooms(detail.rooms);
		}
	},
);
